import { Colors } from '@/assets';

export default function componentStyleOverrides() {
    return {
        MuiAlert: {
            styleOverrides: {
                root: {
                    padding: '0.5rem 1.5rem !important'
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                    boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                    '&:hover': {
                        transform: 'scale(1.01)',
                        transition: 'all 0.2s ease-in-out'
                    }
                }
            }
        },
        MuiLinearProgress: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                    height: 8,
                    backgroundColor: Colors.softPeach,
                    '& > span': {
                        backgroundColor: Colors.mediumPurpleViolet
                    }
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: 16,
                    border: '1px solid',
                    borderColor: Colors.greenWhite,
                    boxShadow: '0px 4px 8px -2px rgba(16, 24, 40, 0.1), 0px 2px 4px -2px rgba(16, 24, 40, 0.06);',
                    overflow: 'auto'
                }
            }
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    borderTop: '1px solid',
                    borderColor: Colors.greenWhite
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    border: 0
                }
            }
        },
        MuiAvatarGroup: {
            styleOverrides: {
                avatar: {
                    zIndex: 'initial !important'
                }
            }
        },
        MuiSwitch: {
            styleOverrides: {
                root: {
                    width: 38,
                    height: 22,
                    padding: 0,
                    '& .MuiSwitch-switchBase': {
                        padding: 0,
                        margin: 3,
                        transitionDuration: '300ms',
                        '&.Mui-checked': {
                            transform: 'translateX(16px)',
                            color: Colors.white,
                            '& + .MuiSwitch-track': {
                                backgroundColor: Colors.mediumPurpleViolet,
                                opacity: 1,
                                border: 0
                            },
                            '&.Mui-disabled + .MuiSwitch-track': {
                                opacity: 0.5
                            }
                        }
                    },
                    '& .MuiSwitch-thumb': {
                        boxSizing: 'border-box',
                        width: 16,
                        height: 16
                    },
                    '& .MuiSwitch-track': {
                        borderRadius: 26 / 2,
                        backgroundColor: Colors.solitudeBlue,
                        opacity: 1,
                        transition: 'background-color 500ms'
                    }
                }
            }
        },
        MuiTabs: {
            styleOverrides: {
                flexContainer: {
                    borderBottom: '1px solid',
                    borderColor: Colors.greenWhite,
                    '& .Mui-selected': {
                        color: `${Colors.slateBlueViolet} !important`,
                        opacity: 1
                    }
                },
                indicator: {
                    background: Colors.slateBlueViolet
                }
            }
        },
        MuiPaginationItem: {
            styleOverrides: {
                root: {
                    fontSize: '1.4rem',
                    color: Colors.lynchBlue,
                    '&.Mui-selected': {
                        background: Colors.magnoliaWhite,
                        color: Colors.mediumPurpleViolet
                    }
                }
            }
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    boxShadow: '0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)',
                    background: Colors.white,
                    border: 0
                }
            }
        },
        MuiBadge: {
            styleOverrides: {
                badge: {
                    backgroundColor: Colors.mountainMeadowGreen,
                    color: Colors.mountainMeadowGreen,
                    boxShadow: `0 0 0 2px #fff`,
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    '&::after': {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        borderRadius: '50%',
                        animation: 'ripple 1.2s infinite ease-in-out',
                        border: '2px solid currentColor',
                        content: '""'
                    }
                }
            }
        }
    };
}
